export enum AddressBookMode {
  Unknown = 'unknown',
  Local = 'local',
  Remote = 'remote',
}

export const ADDRESS_BOOK_SETTING_KEY = 'address-book-mode';
